import { useState } from "react";
import { rascunhosLocais } from "@/mocks/coletor";

interface DraftsListProps {
  onClose: () => void;
  onEdit: (id: string) => void;
}

const tipoIcons: Record<string, { icon: string; bg: string }> = {
  nova_arvore: { icon: "ri-leaf-line", bg: "bg-[#1B6E4F]" },
  vistoria: { icon: "ri-clipboard-line", bg: "bg-[#0052CC]" },
  fotos: { icon: "ri-camera-line", bg: "bg-[#3F4A52]" },
};

const statusConfig: Record<string, { label: string; text: string; bg: string }> = {
  completo: { label: "Completo", text: "text-[#1B6E4F]", bg: "bg-[#CAF0D3]" },
  incompleto: { label: "Incompleto", text: "text-[#F57C00]", bg: "bg-[#FFF3E0]" },
  erro: { label: "Erro", text: "text-[#D32F2F]", bg: "bg-[#FFEBEE]" },
};

export default function DraftsList({ onClose, onEdit }: DraftsListProps) {
  const [filtro, setFiltro] = useState("todos");

  const filtros = [
    { key: "todos", label: "Todos" },
    { key: "nova_arvore", label: "Árvores" },
    { key: "vistoria", label: "Vistorias" },
    { key: "fotos", label: "Fotos" },
  ];

  const itensFiltrados = filtro === "todos" ? rascunhosLocais : rascunhosLocais.filter((r) => r.tipo === filtro);

  return (
    <div className="px-4 pt-4 pb-20 max-w-lg mx-auto">
      <div className="flex items-center gap-2 mb-5">
        <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[#E8EAED] flex items-center justify-center">
          <i className="ri-arrow-left-line text-[#3F4A52] text-lg" />
        </button>
        <h2 className="text-lg font-heading font-bold text-[#3F4A52]">Rascunhos</h2>
        <span className="ml-auto text-xs px-2 py-0.5 rounded-full bg-[#F57C00]/15 text-[#F57C00] font-medium">{rascunhosLocais.length}</span>
      </div>

      {/* Filtros */}
      <div className="flex gap-2 mb-4 overflow-x-auto no-scrollbar pb-1">
        {filtros.map((f) => (
          <button
            key={f.key}
            onClick={() => setFiltro(f.key)}
            className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
              filtro === f.key ? "bg-[#1B6E4F] text-white" : "bg-white border border-[#E8EAED] text-[#3F4A52]"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Lista */}
      <div className="space-y-2">
        {itensFiltrados.map((rascunho) => {
          const tipo = tipoIcons[rascunho.tipo] || tipoIcons.nova_arvore;
          const status = statusConfig[rascunho.status] || statusConfig.incompleto;
          return (
            <div key={rascunho.id} className="bg-white border border-[#E8EAED] rounded-xl p-3">
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-xl ${tipo.bg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${tipo.icon} text-white text-lg`} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-0.5">
                    <p className="text-sm font-medium text-[#3F4A52] truncate">
                      {rascunho.tipo === "nova_arvore" ? "Nova Árvore" : rascunho.tipo === "vistoria" ? "Vistoria" : "Fotos"}
                    </p>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${status.text} ${status.bg}`}>{status.label}</span>
                  </div>
                  <p className="text-xs font-mono text-[#3F4A52]/50">{rascunho.codigo}</p>
                  <p className="text-xs text-[#3F4A52]/50">{rascunho.especie} · {rascunho.data}</p>
                  {rascunho.pendencia && (
                    <p className="text-xs text-[#F57C00] mt-1 flex items-center gap-1">
                      <i className="ri-error-warning-line text-[10px]" /> {rascunho.pendencia}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex gap-2 mt-3 pt-3 border-t border-[#E8EAED]">
                <button onClick={() => onEdit(rascunho.id)} className="flex-1 py-2 rounded-lg border border-[#E8EAED] text-xs font-medium text-[#3F4A52] hover:bg-[#E8EAED]/30">
                  <i className="ri-edit-line mr-0.5" /> Editar
                </button>
                <button className="flex-1 py-2 rounded-lg bg-[#1B6E4F] text-white text-xs font-heading font-bold">
                  <i className="ri-cloud-line mr-0.5" /> Sincronizar
                </button>
                <button className="w-8 h-8 rounded-lg bg-[#FFEBEE] text-[#D32F2F] flex items-center justify-center flex-shrink-0">
                  <i className="ri-delete-bin-line text-xs" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}